import React from 'react'
import styles from './styles.module.scss'

const LoadingSpinner = ({open = false, className, ...props}) =>
  open &&
    <span className={[styles.spinnerMainContainer, className].join(' ')} {...props}>
      <img src="./image/spinner.svg" alt="Loading..." height="50"/>
    </span>

export {LoadingSpinner}
export default LoadingSpinner
